import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Cookie } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import './CookieBanner.css';

const CookieBanner = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // Show banner after a short delay
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'true');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'false');
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          className="cookie-banner"
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.5, type: "spring", stiffness: 100 }}
        >
          <div className="cookie-content">
            <div className="cookie-icon">
              <Cookie size={24} />
            </div>
            <div className="cookie-text">
              <h3>{t('cookie.title', 'Wij gebruiken cookies')}</h3>
              <p>
                {t('cookie.text', 'Wij gebruiken cookies om uw ervaring op onze website te verbeteren. Door op Accepteren te klikken, gaat u akkoord met ons')} <Link to="/cookies">{t('cookie.link', 'cookiebeleid')}</Link>.
              </p>
            </div>
          </div>
          <div className="cookie-actions">
            <button onClick={handleDecline} className="btn-cookie-decline">
              {t('cookie.decline', 'Weigeren')}
            </button>
            <button onClick={handleAccept} className="btn-cookie-accept">
              {t('cookie.accept', 'Accepteren')}
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
